module.exports = "pegasus/assets/theme3/medium/8.jpg";